import React from 'react';
// import * as Sentry from '@sentry/browser';

export default class ErrorBoundary extends React.PureComponent {
  state = {
    somethingWentWrong: false,
    error: null
  };

  static getDerivedStateFromError(error) {
    // debugger;
    // Update state so the next render will show the fallback UI.
    return {
      error: error.message
    };
  }

  componentDidCatch(error, _errorInfo) {
    /*
     * In case on any exception say to host app release foreground, at last tu try.
     */
    // console.error('Something went wrong\n', error);
    // this.actions.hostApp.releaseForeground();

    this.props.onError(error.message, true /* Should be "fatal"? */);
/*
    Sentry.withScope((scope) => {
      scope.setExtras(errorInfo);
      const eventId = this.props.Sentry.captureException(error);
      this.setState({ eventId });
    });
*/
  }

  sendReport = () => {
    // Sentry.showReportDialog({ eventId: this.state.eventId });
  };

  render() {
    if (this.state.error !== null) {
/*
      // Not so useful in our case, button still in iframe and almost unavailable for interaction
      // TODO: investigate possibility to uplift, e.g. "fullscreen", interactive layer in error reporting mode
        return (
          <button onClick={this.sendReport}>Report feedback</button>
        );
*/
      return null;
    }

    return this.props.children;
  }
}
